import msr from "./masterrecordService";
import tmpl from "./templateService";
import sconf from "./serviceConfigService";
import sow from "./sowService";
import baa from "./baaService";
import nda from "./ndaService";
import baa_nda from "./baa_ndaService";
import mdr from "./mdrService";
import postir from "./postirService";
import projects from "./projectService";
export default {
  master: msr,
  template: tmpl,
  serviceConfig: sconf,
  sow: sow,
  baa: baa,
  nda: nda,
  baa_nda: baa_nda,
  mdr: mdr,
  postir: postir,
  projects,
};
